import { SearchApi } from '@ps/api/search';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Total channel-member count for a filter (All when `blocked` is omitted,
 * Blocked when `true`). Reads the search response `total` with a 1-row page —
 * the count drives the All/Blocked tab labels, so the rows themselves are
 * loaded separately by {@link fetchChannelMembers}.
 */
export async function fetchChannelMemberCount(
  creatorId: string,
  channelId: string,
  { blocked }: { blocked?: boolean } = {},
): Promise<number> {
  const api = withClientAPI(SearchApi);
  const res = await api.searchApiControllerSearchStoreCommunityChannelMembers({
    storeId: creatorId,
    channelId,
    pageNo: 1,
    pageSize: 1,
    blocked,
  });
  return res.total;
}
